import Vue from 'vue';
import { getMeasures } from './../../api/device';

const state = {
  devices: {},
  lastUpdate: new Date()
};

const getters = {
  measures: state => id => {
    if(state.devices.hasOwnProperty(id)){
      return state.devices[id];
    }

    return null;
  }
};

const actions = {
  async fetchDeviceData({state, rootState, commit}, {deviceId, dateFrom, dateTo, type}){

    console.log(rootState.dashboardFilter.dateFrom.format('HH:mm DD-MM-YYYY'),dateFrom.format('HH:mm DD-MM-YYYY'));

    const deviceData = await getMeasures(rootState.user.authTokens.accessToken,deviceId,{
      dateFrom: dateFrom.format('HH:mm DD-MM-YYYY'),
      dateTo: dateTo.format('HH:mm DD-MM-YYYY'),
      type
    });

    if(deviceData.data){
      commit('setDeviceData', deviceData.data);
    }
  }
};

const mutations = {
  setDeviceData(state, object){
    if(state[object.deviceId]){
      state[object.deviceId].measures = [];
    }
    Vue.set(state.devices, object.deviceId, object);
  },
  removeMeasures(state, object)
  {
    if(state[object.deviceId]){
      Vue.set(state.devices[object.deviceId], 'measures', null);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
